import React, { useState, useEffect } from 'react';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Slider from '@mui/material/Slider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';





// import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';


function MaterialDateTimePicker({handleChange}) {
    const handleInnerChange = (value) => {
        handleChange(value); 
    }
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDateTimePicker sx={{ m: 1, width: 300 }} onChange={handleInnerChange}/>
            </LocalizationProvider>
        </div>
    );
}

function BasicDatePicker({handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('in the picker', event.$d)
        handleChange(event.$d); 
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker onChange={handleInnerChange} sx={{ m: 1, width: 300 }}/>
        </LocalizationProvider>
    );
}

function MaterialSelectGeneral({elements, label, multipleSelect = 'true', handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function MaterialMultilineTextField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function MateriaBasicTextField({placeholder, defaultValue, label, handleChange, value}) {
    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }
    return (
        <TextField value={value} onChange={handleInnerChange} sx={{ m: 1, width: 300 }} id="outlined-basic" label={label} variant="outlined" placeholder={placeholder} defaultValue = {defaultValue} />
    );
}


function MateriaBasicTimePicker({placeholder, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('in the picker', event.$d)
        handleChange(event.$d); 
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker onChange={handleInnerChange} sx={{ m: 1, width: 300 }} label={placeholder} />  
        </LocalizationProvider>
        // <TimePicker sx={{ m: 1, width: 300 }} label={placeholder} />  
    );
}

function MaterialStatusSelect({placeholder, handleChange}) {
    const [status, setStatus] = React.useState('');
    const handleChangeSelect = (event) => {
        setStatus(event.target.value);
        handleChange(event.target.value)
    };


    return (
        <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="demo-simple-select-label">Goal Status</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status}
                label="Goal Status"
                onChange={handleChangeSelect}
            >
                <MenuItem value={'Not Started'}>Not Started </MenuItem>
                <MenuItem value={'In Progress'}>In Progress</MenuItem>
                <MenuItem value={'Deferred'}>Deferred</MenuItem>
                <MenuItem value={'Abandoned'}>Abandoned</MenuItem>
                <MenuItem value={'Completed'}>Completed</MenuItem>
            </Select>
        </FormControl>
    );
}

function MaterialDiscreteSlider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function MaterialPassword({label, handleChange}){
    const [showPassword, setShowPassword] = useState(false);

    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }

    return(
        <div>
            <TextField
                variant="outlined"
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                onChange={handleInnerChange}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    )
}

function MaterialResetPassword({label, handleChange}){
    const [showPassword, setShowPassword] = useState(false);

    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }

    return(
        <div>
            <TextField
                variant="outlined"
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                onChange={handleInnerChange}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    )
}

function MaterialResetPasswordConfirm({label, handleChange}){
    const [showPassword, setShowPassword] = useState(false);

    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }

    return(
        <div>
            <TextField
                variant="outlined"
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                onChange={handleInnerChange}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    )
}
//Landing Page Questions
function LandingName({placeholder, defaultValue, label, handleChange, value}) {
    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }
    return (
        <TextField value={value} onChange={handleInnerChange} sx={{ m: 1, width: 300 }} id="outlined-basic" label={label} variant="outlined" placeholder={placeholder} defaultValue = {defaultValue} />
    );
}

//Onboarding questions

//new onboarding questions
function OnboardingAboutYou({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function OnboardingVizSuccess({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function OnboardingGoalsYear({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function OnboardingGoalsQuarter({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function OnboardingGoalsMonth({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function OnboardingGoalsWeek({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function OnboardingFriendAdvice({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}


function DOBDatePicker({handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('in the picker', event.$d)
        handleChange(event.$d); 
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker onChange={handleInnerChange} sx={{ m: 1, width: 300 }}/>
        </LocalizationProvider>
    );
}
function GenderSelect({elements, label, multipleSelect = 'true', handleChange, defaultValue = []}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    useEffect(() => {
        //console.log('loading gender yo')
        if (defaultValue.length > 0) {
            setElementName(defaultValue);
        }
        //console.log('default value: ', defaultValue)
    }, [defaultValue]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function JoiningReasonSelect({elements, label, multipleSelect = 'true', handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function TimeSpentSelect({elements, label, multipleSelect = 'true', handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function ProblematicBehaviorsSelect({elements, label, multipleSelect = 'true', handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function GoalTextField({placeholder, defaultValue, label, handleChange, value}) {
    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }
    return (
        <TextField value={value} onChange={handleInnerChange} sx={{ m: 1, width: 300 }} id="outlined-basic" label={label} variant="outlined" placeholder={placeholder} defaultValue = {defaultValue} />
    );
}

function CaplanScalePOSI1Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScalePOS2Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScalePOS3Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleMR1Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleMR2Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

// function CaplanScalePOSI1Slider({placeholder, min= 0, max=10, handleChange}) {
//     function valuetext(value) {
//         handleChange(String(value))
//         return `${value}`;
//     }
//     return (
//         <div>
//             <Slider
//                 aria-label="Scale"
//                 defaultValue={5}
//                 getAriaValueText={valuetext}
//                 valueLabelDisplay="auto"
//                 step={1}
//                 min={Number(min)}
//                 max={Number(max)}
//                 sx={{ m: 1, width: 300 }}
//             />
//         </div>
//     );
// }

function CaplanScaleMR3Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleCP1Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleCP2Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleCP3Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleCIU1Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleCIU2Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleCIU3Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleNO1Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleNO2Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function CaplanScaleNO3Slider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function TreatmentsSelect({elements, label, multipleSelect = 'true', handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function FailureReasonsTextField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function TimeCommitmentSelect({elements, label, multipleSelect = 'true', handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(element, elementName, theme) {
        return {
            fontWeight:
            elementName.indexOf(element) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }

    const theme = useTheme();
    const [elementName, setElementName] = React.useState([]);

    const handleInnerChange = (event) => {
        const { target: { value }} = event;
        setElementName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple = {multipleSelect === "true"}
                value={elementName}
                onChange={handleInnerChange}
                input={<OutlinedInput label={label} />}
                MenuProps={MenuProps}
                >
                {elements.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, elementName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function WorkoutTimeSelect({placeholder, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('in the picker', event.$d)
        handleChange(event.$d); 
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker onChange={handleInnerChange} sx={{ m: 1, width: 300 }} label={placeholder} />  
        </LocalizationProvider>
        // <TimePicker sx={{ m: 1, width: 300 }} label={placeholder} />  
    );
}

// function WorkoutTimeSelect({elements, label, multipleSelect = 'true', handleChange}){
//     const ITEM_HEIGHT = 48;
//     const ITEM_PADDING_TOP = 8;
//     const MenuProps = {
//         PaperProps: {
//             style: {
//             maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//             width: 250,
//             },
//         },
//     };
//     function getStyles(element, elementName, theme) {
//         return {
//             fontWeight:
//             elementName.indexOf(element) === -1
//                 ? theme.typography.fontWeightRegular
//                 : theme.typography.fontWeightMedium,
//         };
//     }

//     const theme = useTheme();
//     const [elementName, setElementName] = React.useState([]);

//     const handleInnerChange = (event) => {
//         const { target: { value }} = event;
//         setElementName(
//             // On autofill we get a stringified value.
//             typeof value === 'string' ? value.split(',') : value,
//         );
//         handleChange(
//             // On autofill we get a stringified value.
//             typeof value === 'string' ? value.split(',') : value,
//         );
//     };

//     return (
//         <div>
//             <FormControl sx={{ m: 1, width: 300 }}>
//                 <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
//                 <Select
//                 labelId="demo-multiple-name-label"
//                 id="demo-multiple-name"
//                 multiple = {multipleSelect === "true"}
//                 value={elementName}
//                 onChange={handleInnerChange}
//                 input={<OutlinedInput label={label} />}
//                 MenuProps={MenuProps}
//                 >
//                 {elements.map((name) => (
//                     <MenuItem
//                     key={name}
//                     value={name}
//                     style={getStyles(name, elementName, theme)}
//                     >
//                     {name}
//                     </MenuItem>
//                 ))}
//                 </Select>
//             </FormControl>
//         </div>
//     );
// }

//Relapse Log

function ProblematicStartPicker({handleChange}) {
    const handleInnerChange = (value) => {
        handleChange(value); 
    }
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDateTimePicker sx={{ m: 1, width: 300 }} onChange={handleInnerChange}/>
            </LocalizationProvider>
        </div>
    );
}

function ProblematicEndPicker({handleChange}) {
    const handleInnerChange = (value) => {
        handleChange(value); 
    }
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDateTimePicker sx={{ m: 1, width: 300 }} onChange={handleInnerChange}/>
            </LocalizationProvider>
        </div>
    );
}

function MaterialSelectBehaviors({handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(name, personName, theme) {
        return {
            fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }
    const names = [
        'Social',
        'Gaming',
        'Porn',
        'Gambling',
        'Streaming',
        'General',
        'Other'
    ];

    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);

    const handleInnerChange = (event) => {
        const {
        target: { value },
        } = event;
        setPersonName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <div>
        <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="demo-multiple-name-label">Behavior(s)</InputLabel>
            <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            multiple
            value={personName}
            onChange={handleInnerChange}
            input={<OutlinedInput label="Behavior(s)" />}
            MenuProps={MenuProps}
            >
            {names.map((name) => (
                <MenuItem
                key={name}
                value={name}
                style={getStyles(name, personName, theme)}
                >
                {name}
                </MenuItem>
            ))}
            </Select>
        </FormControl>
        </div>
    );
}

function MaterialSelectDevices({handleChange}){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    function getStyles(name, personName, theme) {
        return {
            fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        };
    }
    const names = [
        'Phone',
        'Tablet',
        'TV',
        'Laptop',
        'Desktop'
    ];

    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);

    const handleInnerChange = (event) => {
        const {
        target: { value },
        } = event;
        setPersonName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        );
        handleChange(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        )
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-name-label">Device(s)</InputLabel>
                <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                value={personName}
                onChange={handleInnerChange}
                input={<OutlinedInput label="Device(s)" />}
                MenuProps={MenuProps}
                >
                {names.map((name) => (
                    <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, personName, theme)}
                    >
                    {name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}

function RelapseDescriptionTextField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function RelapseReasoningTextField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function RelapseImprovementTextField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function RelapseImpactSlider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function RelapseImpactDescription({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

//Learning
function ContentRelevanceSlider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}
function LearningContentRequest({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Tomorrow Workout Input"
                defaultValue="Continue Trampoline Curriculum"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}
function LearingContentTakeawaysField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Learning Content Takeaways"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function DailyPromptTextField({placeholder, rows=5, defaultValue, label, handleChange, value}){
    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }

    return(
        <div>
            <TextField
                variant="outlined"
                onChange={handleInnerChange}
                label={label}
                multiline
                rows={rows}
                placeholder={placeholder} 
                defaultValue = {defaultValue}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    )
}

function DailyGoalTextField({placeholder, rows=5, defaultValue, label, handleChange, value}){
    const handleInnerChange = (event) => {
        handleChange(event.target.value); 
    }

    return(
        <div>
            <TextField
                variant="outlined"
                onChange={handleInnerChange}
                label={label}
                multiline
                rows={rows}
                placeholder={placeholder} 
                defaultValue = {defaultValue}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    )
}

function DailyGoalDueDate({placeholder, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('in the picker', event.$d)
        handleChange(event.$d); 
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker onChange={handleInnerChange} sx={{ m: 1, width: 300 }} label={placeholder} />  
        </LocalizationProvider>
        // <TimePicker sx={{ m: 1, width: 300 }} label={placeholder} />  
    );
}

function GoalReasoningTextField({placeholder, rows=5, handleChange, label= "Description"}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label={ label }
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function DailyCurrentConfidenceSlider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function DailyRecentTechUseSlider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function ProgressTakeawaysTextField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function DailyVizSlider({placeholder, min= 0, max=10, handleChange}) {
    function valuetext(value) {
        handleChange(String(value))
        return `${value}`;
    }
    return (
        <div>
            <Slider
                aria-label="Scale"
                defaultValue={5}
                getAriaValueText={valuetext}
                valueLabelDisplay="auto"
                step={1}
                min={Number(min)}
                max={Number(max)}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function DailyVizReflectionField({placeholder, rows=5, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

// Goal Submission Inputs


function GoalCompletedTextField({placeholder, rows=5, handleChange, label= "Description"}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="goalCompletedInput"
                label={ label }
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}


function GoalReflectionTextField({placeholder, rows=5, handleChange, label= "Description"}) {
    const handleInnerChange = (event) => {
        //console.log('multiline event: ', event)
        handleChange(event.target.value); 
    }
    return (
        <div>
            <TextField
                onChange={handleInnerChange}
                id="goalReflectionInput"
                label={ label }
                multiline
                rows={rows}
                placeholder={placeholder}
                sx={{ m: 1, width: 300 }}
            />
        </div>
    );
}

function GoalCompletionTime({placeholder, handleChange}) {
    const handleInnerChange = (event) => {
        //console.log('in the picker', event.$d)
        handleChange(event.$d); 
    }
    return (
        <LocalizationProvider id="goalCompletionDateInput" dateAdapter={AdapterDayjs}>
            <TimePicker onChange={handleInnerChange} sx={{ m: 1, width: 300 }} label={placeholder} slotProps={{
                    textField: {
                        id: "goalCompletionDateInput" // ✅ Set the ID directly on the input
                    }
                }} />  
        </LocalizationProvider>
        // <TimePicker sx={{ m: 1, width: 300 }} label={placeholder} />  
    );
}

//Goal Completion Exports
export{ GoalCompletionTime, GoalReflectionTextField, GoalCompletedTextField}

export { ContentRelevanceSlider, LearningContentRequest, LearingContentTakeawaysField, DailyVizReflectionField, DailyVizSlider, DailyRecentTechUseSlider, DailyCurrentConfidenceSlider, DailyGoalDueDate, RelapseImpactDescription, RelapseImpactSlider, ProblematicEndPicker, ProblematicStartPicker, FailureReasonsTextField, TimeSpentSelect, WorkoutTimeSelect, TimeCommitmentSelect, TreatmentsSelect, CaplanScaleNO3Slider, CaplanScaleNO2Slider, CaplanScaleNO1Slider, CaplanScaleCIU3Slider, CaplanScaleCIU2Slider, CaplanScaleCIU1Slider, CaplanScaleCP3Slider, CaplanScaleCP2Slider, CaplanScaleCP1Slider, CaplanScaleMR3Slider, CaplanScaleMR2Slider, CaplanScaleMR1Slider, CaplanScalePOSI1Slider, CaplanScalePOS2Slider, CaplanScalePOS3Slider,  GoalTextField, ProblematicBehaviorsSelect, JoiningReasonSelect, GenderSelect, DOBDatePicker, RelapseDescriptionTextField, RelapseReasoningTextField, RelapseImprovementTextField, GoalReasoningTextField, ProgressTakeawaysTextField, DailyPromptTextField, DailyGoalTextField, MaterialDateTimePicker, MaterialSelectBehaviors, MaterialSelectDevices, MaterialMultilineTextField, MateriaBasicTextField, MateriaBasicTimePicker, MaterialStatusSelect, MaterialDiscreteSlider, MaterialSelectGeneral, BasicDatePicker, MaterialPassword, MaterialResetPassword, MaterialResetPasswordConfirm, OnboardingFriendAdvice, OnboardingGoalsWeek, OnboardingGoalsMonth, OnboardingGoalsQuarter, OnboardingGoalsYear, OnboardingVizSuccess, OnboardingAboutYou, LandingName}